export default __webpack_public_path__ + "static/media/bag.d614d7b3.jfif";